export default __webpack_public_path__ + "static/media/icon-configuracoes.4991b377.svg";